import { z } from "zod";
import { npdCalculationResultParameterDecimalPlacesDtoSchema } from "./npd-calculation-result-parameter-decimal-places.schema";
export const npdCalculationResultParameterDtoSchema = z.object({
    name: z.string(),
    value: z.number(),
    unit: z.string(),
    show: z.boolean(),
    decimalPlaces: npdCalculationResultParameterDecimalPlacesDtoSchema,
    labelSuffix: z.string().optional(),
});
